import { useMemo } from "react";

type Kind = 'left_hand' | 'right_hand';

export interface Annotation {
  groupID: number;
  groupSize: number;
  kind: Kind;
  text: string;
}

// determine keys based on key, type, mode, range and hand toggles
const useFingeringAnnotations = (
  highlightedKeys: Array<number>,
  lhFingering: string,
  rhFingering: string
) => {
  // Convert "123 1234 1" to [[1, 2, 3], [1, 2, 3, 4], [1]]
  const lhGroups = useMemo(() => lhFingering.split(' ').map(g => g.split('')), [lhFingering]);
  const rhGroups = useMemo(() => rhFingering.split(' ').map(g => g.split('')), [rhFingering]);
  const combinedGroups = [
    ...lhGroups.map(g => ({group: g, kind: 'left_hand' as Kind})),
    ...rhGroups.map(g => ({group: g, kind: 'right_hand' as Kind}))
  ];

  // Group annotations by highlighted keys
  const annotationsByKeyID: {[key: number]: Array<Annotation>} = {};
  let acc = 0;
  for (let i = 0; i < combinedGroups.length; i++) {
    const g = combinedGroups[i]
    const groupID = i;
    const groupSize = g.group.length;

    for (let j = 0; j < g.group.length; j++) {
      const key = highlightedKeys[acc % highlightedKeys.length];
      annotationsByKeyID[key] = annotationsByKeyID[key] || [];
      annotationsByKeyID[key].push({
        groupID,
        groupSize,
        kind: g.kind,
        text: g.group[j]
      });

      acc++;
    }
  }

  return {
    lhGroups,
    rhGroups,
    annotationsByKeyID,
  };
};

export default useFingeringAnnotations;
